<div class="notes-snackbar-text">{{ message }}</div>
<div class="notes-snackbar-button-div" *ngIf="hasAction" (click)="dismiss()">
    <span class="notes-snackbar-action-button">{{ action }}</span>
</div>